/**
 * Templates Feature - i18n 注册
 */

import { addLocaleMessages } from '@/i18n';
import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import enUS from './locales/en-US';
import jaJP from './locales/ja-JP';

// 注册 templates 相关的多语言
addLocaleMessages('cn', { templates: zhCN });
addLocaleMessages('tw', { templates: zhTW });
addLocaleMessages('en', { templates: enUS });
addLocaleMessages('jp', { templates: jaJP });
